import React, { useState, useCallback } from "react";
import SearchIcon from '@mui/icons-material/Search';
import { GlobalStyles } from '@mui/system';

import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { Autocomplete, CircularProgress, TextField, Button, Box ,Typography ,MenuItem ,Checkbox} from "@mui/material";
import { styled } from "@mui/system";
import debounce from 'lodash/debounce';
import { STATE_ENTITIES } from "utils/entities";
import { createApiThunk } from "store/thunks/apiThunks";

import { venueSearchByName } from "services/venueService";
// Custom styled components
const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};



const CalenderTextField = styled(TextField)(({ theme }) => ({
  flex: 1,
  backgroundColor: 'white',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderRadius: '0',
      borderLeft: '1px solid #D0D0D0',
      borderTop: 'transparent',
      borderRight: 'transparent',
      borderBottom: 'transparent',
    },
    '&:hover fieldset': {
      borderColor: 'transparent',
      borderLeft: '1px solid #D0D0D0',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'transparent',
      borderLeft: '1px solid #D0D0D0',
    },
  },

  [theme.breakpoints.down('sm')]: {
    marginTop: '10px',
    borderRadius: '50px',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderRadius: '0',
        borderLeft: '1px solid transparent',
      },
      '&:hover fieldset': {
        borderColor: 'transparent',
        borderLeft: '1px solid transparent',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'transparent',
        borderLeft: '1px solid transparent',
      },
    },
  },
}));



const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  flex: 1,
  width: '100%', // Ensure full width on all screen sizes
  '& .MuiAutocomplete-inputRoot': {
    borderRadius: '50px',
    padding: '0px 14px',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderRadius: '0',
      borderColor: 'transparent',
    },
    '&:hover fieldset': {
      borderColor: 'transparent',
      borderLeft: '1px solid transparent',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'transparent',
      borderLeft: '1px solid transparent',
    },
  },
  // Responsive styles
  [theme.breakpoints.down('sm')]: {
    marginTop: '10px',
    borderRadius: '50px',
    padding: '0px 0px',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderRadius: '0',
        borderLeft: '1px solid transparent',
      },
    },
    '&:hover fieldset': {
      borderColor: 'transparent',
      borderLeft: 'transparent',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'transparent',
      borderLeft: '1px solid transparent',
    },
  },
}));

const CapacityTextField = styled(TextField)(({ theme }) => ({
  flex: 1,
  borderRadius: '0px',
  backgroundColor: '#FFFFFF',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderRadius: '0',
      borderLeft: '1px solid #D0D0D0',
      borderTop: 'transparent',
      borderRight: 'transparent',
      borderBottom: 'transparent',
    },
    '&:hover fieldset': {
      borderColor: 'transparent',
      borderLeft: '1px solid #D0D0D0',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'transparent',
      borderLeft: '1px solid #D0D0D0',
    },
  },
  // Responsive styles
  [theme.breakpoints.down('sm')]: {
    marginTop: '10px',
    borderRadius: '50px',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderRadius: '50px',
        borderLeft: '1px solid transparent',
      },
    },
  },
}));

const SearchBox = styled("div")(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '50px 0 0 0',
  [theme.breakpoints.down('sm')]: {
    margin: '10px 0 0 0',
  },
  [theme.breakpoints.between('md', 'lg')]: {
    margin: '15px 0 0 0',
  },
}));

const SearchButton = styled(Button)(({ theme }) => ({
  minWidth: '0',
  borderRadius: '50px',
  padding: 12,
  color: 'white',
  backgroundColor: '#FF5F00',
  '&:hover': {
    backgroundColor: 'red',
  },
  [theme.breakpoints.down("sm")]: {
    width: '100%',
    marginTop: '10px',
    alignSelf: 'center',
    borderRadius: '50px',
    padding: '10px 70px',
  }
}));

const SearchText = styled(Typography)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down("sm")]: {
    fontsize: '12px',
    display: 'block',
    fontWeight: 'bold',
  }
}));

const NameTextField = styled(TextField)(({ theme }) => ({
  flex: 1,
  backgroundColor: '#FFFFFF',
  borderRadius: '50px',
  padding: '0px 0px',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderRadius: '0',
      borderColor: 'transparent',
    },
    '&:hover fieldset': {
      borderColor: 'transparent',
      borderLeft: '1px solid transparent',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'transparent',
      borderLeft: '1px solid transparent',
    },
  },
  // Responsive styles
  [theme.breakpoints.down('sm')]: {
    marginTop: '10px',
    borderRadius: '50px',
    padding: "9.5px 0",
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderRadius: '0',
        borderLeft: '1px solid transparent',
      },
    },
    '&:hover fieldset': {
      borderColor: 'transparent',
      borderLeft: 'transparent',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'transparent',
      borderLeft: '1px solid transparent',
    },
  },
}));
const Overlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100vh',
  zIndex: 1,
  background: 'linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.5))',
  [theme.breakpoints.down('md')]: {
    height: '100vh',
  },
  [theme.breakpoints.down('sm')]: {
    height: '112vh',
  },
}));

const AsyncAutocomplete = () => {
  const capacity_options = [
    { label: 'Less than 100 guests', value: '0-99', min: 0, max: 99 },
    { label: '100 - 200 guests', value: '100-200', min: 100, max: 200 },
    { label: '200 - 400 guests', value: '200-400', min: 200, max: 400 },
    { label: '400 - 800 guests', value: '400-800', min: 400, max: 800 },
    { label: '800 - 1000 guests', value: '800-1000', min: 800, max: 1000 },
    { label: 'More than 1000 guests', value: '1000+', min: 1000, max: 100000 },
  ];


  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const dispatch = useDispatch();

  const venueSearchState = useSelector((state) => state.api[STATE_ENTITIES.VENUE.SEARCH_BY_NAME]);
  const loading = venueSearchState?.loading;
  const options = venueSearchState?.data?.venues || [];

  const fetchVenueNames = useCallback((searchTerm) => {
    const dynamicThunk = createApiThunk(STATE_ENTITIES.VENUE.SEARCH_BY_NAME, venueSearchByName, { searchTerm  , request_type : "web"});
    dispatch(dynamicThunk({ entity: STATE_ENTITIES.VENUE.SEARCH_BY_NAME }));
  }, [dispatch]);

  const debouncedFetchVenueNames = useCallback(
    debounce((searchTerm) => {
      if (searchTerm.length > 2) {
        fetchVenueNames(searchTerm);
      }
    }, 300),
    [fetchVenueNames]
  );

  const handleInputChange = (event, newInputValue, reason) => {
    setInputValue(newInputValue);
    if (reason === 'input') {
      debouncedFetchVenueNames(newInputValue);
    }
  };

  return (
    <Overlay>

    <Box sx={{ padding: '20px' }}>
      <Formik
        initialValues={{ venue: null }}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false);
        }}
      >
        {({ setFieldValue, values ,isValid, dirty }) => (
           <Form>
           <SearchBox>
            <GlobalStyles styles={{ body: { paddingRight: '0 !important', overflow: 'visible !important', }, }} />
            <Box
                    sx={{
                      width: '80%',
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                      alignItems: 'center',
                      padding: '0 10px',
                      borderRadius: '50px',
                      backgroundColor: {
                        xs: 'none',
                        sm: '#FFFFFF',
                        lg: '#FFFFFF',
                      },
                      boxShadow: {
                        xs: '0',
                        lg: '3',
                      },
                    }}
                  >
            <Field name="venue">
              {({ field }) => (
                <StyledAutocomplete
                fullWidth
                  {...field}
                  freeSolo
                  id="venue-autocomplete"
                  open={open}
                  onOpen={() => setOpen(true)}
                  onClose={() => setOpen(false)}
                  isOptionEqualToValue={(option, value) => option.venue_name === value.venue_name}
                  getOptionLabel={(option) => typeof option === 'string' ? option : option.venue_name || ''}
                  options={options}
                  loading={loading}
                  inputValue={inputValue}
                  onInputChange={handleInputChange}
                  renderInput={(params) => (
                    <NameTextField
                      {...params}
                      placeholder="Search by Name..."
                      // placeholder="Search by Name, Location"

                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.venue_name}
                    </li>
                  )}
                  value={values.venue}
                  onChange={(event, newValue) => {
                    setFieldValue('venue', newValue);
                  }}
                />
              )}
            </Field>


            <Field
                      name="capacity"
                      as={CapacityTextField}
                      select
                      fullWidth
                      SelectProps={{
                        multiple: false,
                        displayEmpty: true,
                        renderValue: (selected) => {
                          const selectedOption = capacity_options && capacity_options.find(
                            option => option?.min === selected?.min && option?.max === selected?.max
                          );
                          return selectedOption ? selectedOption?.label : <em>Select Capacity</em>;
                        },
                        onChange: (event) => {
                          const selectedOption = capacity_options && capacity_options.find(
                            option => option?.value === event?.target?.value
                          );
                          setFieldValue('capacity', {
                            min: selectedOption?.min,
                            max: selectedOption?.max
                          });
                        }
                      }}
                    >
                      <MenuItem value="" disabled>
                        <em>Select Capacity</em>
                      </MenuItem>

                      {capacity_options &&capacity_options.map((option) => (
                        <MenuItem key={option?.value} value={option?.value}>
                          <Checkbox checked={
                            values?.capacity?.min === option?.min &&
                            values?.capacity?.max === option?.max
                          } />
                          {option?.label}
                        </MenuItem>
                      ))}
                    </Field>


<Field
                      as={CalenderTextField}
                      type='date'
                      name='event_date'
                      placeholder="Select Date"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ inputProps: { min: getCurrentDate(), }, }}
                      onClick={(e) => {
                        e.target.showPicker();
                      }}
                    />

            <SearchButton type="submit"
                      variant="contained"
                      disabled={!(isValid && dirty)}
                      sx={{
                        backgroundColor: !(isValid && dirty) ? 'rgba(255, 255, 255, 0.1)' : '#FF5F00',
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                          backgroundColor: !(isValid && dirty)
                            ? 'rgba(255, 255, 255, 0.1)'
                            : '#E56417',
                          // background: 'rgba(255, 255, 255, 0.1)',
                          backdropFilter: 'blur(10px)',
                        },
                      }}
                      >
                      <SearchIcon />
                      <SearchText>Search</SearchText>
                    </SearchButton>
          
          </Box>
          </SearchBox>
          </Form>
        )}
      </Formik>
    </Box>
    </Overlay>
  );
};
export default AsyncAutocomplete;